import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { checkAndCreateTables, checkDatabaseConnection } from './lib/checkAndCreateTables';
import { fixDatabase, fixSecurityPolicies } from './lib/fixDatabase';
import { supabase } from './lib/supabase';
import { TransactionVerifier } from './services/transactionVerifier';
import { PaykuValidator } from './services/paykuValidator';
import { Toaster, toast } from 'react-hot-toast';
import { VerificationProvider } from './contexts/VerificationContext';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

// Verificar y corregir la base de datos al iniciar la aplicación
(async () => {
  try {
    // Verificar conexión a la base de datos
    const isConnected = await checkDatabaseConnection();
    
    if (isConnected) {
      // Corregir estructura de la base de datos
      await fixDatabase();
      
      // Corregir políticas de seguridad
      await fixSecurityPolicies();
      
      // Verificar y crear tablas
      await checkAndCreateTables();
      
      // Verificar que no haya transacciones acreditadas incorrectamente
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session && session.user) {
          console.log('[MAIN] Verificando transacciones para el usuario:', session.user.id);
          
          // Ejecutar la validación de transacciones
          const validationResult = await TransactionVerifier.validateAndRevertIncorrectCredits(session.user.id);
          
          // Mostrar notificación si validateUserTransactions encontró problemas
          if (validationResult.corrected && validationResult.count > 0) {
            console.log('[MAIN] Se corrigieron transacciones incorrectas:', validationResult);
            
            // Mostrar notificación al usuario solo si se corrigieron transacciones
            setTimeout(() => {
              toast.error(
                `Se detectaron y corrigieron ${validationResult.count} transacciones incorrectas. Tu saldo ha sido ajustado.`,
                { duration: 6000 }
              );
            }, 2000);
            
            // Disparar evento para actualizar las monedas en el header
            window.dispatchEvent(new Event('coinsUpdated'));
          } else {
            console.log('[MAIN] No se encontraron transacciones incorrectas');
          }
        }
      } catch (validationError) {
        console.error('[MAIN] Error al validar transacciones:', validationError);
      }
    }
  } catch (error) {
    console.error('Error al inicializar la base de datos:', error);
  }
})();

// Componente para mostrar notificaciones toast
const ToasterComponent = () => {
  return <Toaster position="top-center" />;
};

console.log("[MAIN] Inicializando aplicación");

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <VerificationProvider>
      <ToasterComponent />
      <App />
    </VerificationProvider>
    <Analytics />
    <SpeedInsights />
  </React.StrictMode>
);
